export const enum GroupListQuery {
	FILTERS = 'filters',
	SORT = 'sort',
}
